<!--AI教师助手-->
<template>
    <div class="container">
        <homeHead ref="homeHead" />
        <div class="ai-page" :class="viewMode==='cards' ? 'is-cards' : ''">
            <!--功能卡片-->
            <div class="ai-card-row" v-if="viewMode==='cards'">
                <div class="ai-card" v-for="c in aiCards" :key="c.title" @click="openModule(c)">
                    <img :src="c.icon" :alt="c.title">
                </div>
            </div>
            <!--功能模块-->
            <div class="module-view" v-else>
                <div class="module-head">
                    <div class="back-pill" @click="backToCards">
                        <el-icon :size="16"><Back /></el-icon>
                        <span>返回</span>
                    </div>
                    <div class="module-title">{{ moduleTitle }}</div>
                </div>
                <div class="module-body">
                    <ai-module :module-key="activeModule" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import homeHead from "@/components/homeHead.vue";
import aiModule from "@/components/aiAssistant/aiModule.vue";

export default {
    components: {homeHead, aiModule},
    name: "homeAiAide",
    data() {
        return {
            activePath: "aiAssistant",
            /*视图模式：cards-功能卡片 module-功能模块*/
            viewMode: "cards",
            activeModule: "",
            moduleTitle: "",
            /*AI功能卡片（预合成图片）*/
            aiCards: [
                { key: 'jiaoan', title: 'AI教案', icon: require('../../assets/screen/AI 184.png') },
                { key: 'xuean', title: 'AI学案', icon: require('../../assets/screen/AI 185.png') },
                { key: 'kejian', title: 'AI课件', icon: require('../../assets/screen/AI 186.png') },
                { key: 'xiti', title: 'AI习题', icon: require('../../assets/screen/AI 187.png') },
            ],
        }
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
    },
    methods: {
        openModule(c){
            this.activeModule = c.key;
            this.moduleTitle = c.title;
            this.viewMode = 'module';
        },
        backToCards(){
            this.viewMode = 'cards';
            this.activeModule = "";
        },
    }
}
</script>
<style lang="scss" scoped>
.container {
    width: 100%;
    min-height: 100vh;
    margin: 0;
    overflow-x: hidden;
}

.ai-page {
    min-height: 100vh;
    box-sizing: border-box;
    padding: 100px 40px 20px;
    background: url("../../assets/screen/homeBg.png") no-repeat center center;
    background-size: cover;
}

.ai-page.is-cards {
    display: flex;
    align-items: center;
}

/*卡片行：图片高宽比 1437/800，宽度同时受视口高度约束，防止纵向溢出*/
.ai-card-row {
    display: flex;
    gap: 60px;
    width: 100%;
    max-width: unquote("min(1600px, calc((100vh - 120px) * 2.227 + 260px))");
    margin: 0 auto;
}

.ai-card {
    flex: 1;
    min-width: 0;
    cursor: pointer;
    transition: transform .2s ease;

    img {
        width: 100%;
        display: block;
    }
}

.ai-card:hover {
    transform: translateY(-4px);
}

/*功能模块*/
.module-view {
    width: 100%;
    max-width: 1840px;
    margin: 0 auto;
}
.module-head {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
}
.back-pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 38px;
    padding: 0 22px;
    box-sizing: border-box;
    font-size: 16px;
    color: #fff;
    background: #ff7f2e;
    border-radius: 19px;
    cursor: pointer;
    flex-shrink: 0;
}
.module-title {
    margin-left: 12px;
    font-size: 22px;
    font-weight: bold;
    color: #1f4e79;
}
.module-body {
    height: calc(100vh - 174px);
}
</style>
